import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { CaveatTypeOption } from "interfaces/caveat-type";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_CAVEAT_TYPES_" }
);

export interface ListCaveatTypesState extends IState {
  data: CaveatTypeOption[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: CaveatTypeOption[];
}

const INITIAL_STATE: ListCaveatTypesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListCaveatTypesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListCaveatTypesState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListCaveatTypesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listCaveatTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListCaveatTypesTypes = Types;
export const ListCaveatTypesActions = Creators;
